import React from 'react';
import PropTypes from 'prop-types';
import './articleAuthor.css';

const ArticleAuthor = props => {
  return (
    <div className="article-author clearfix">
      <div
        className="img img-circle pull-left"
        style={{ backgroundImage: `url(${props.image})` }}
      />
      <div className="title-container">
        <div className="title">{props.title}</div>
        <div className="subtitle text-primary">{props.subtitle}</div>
      </div>
    </div>
  );
};

ArticleAuthor.defaultProps = {};

ArticleAuthor.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.object,
  image: PropTypes.string.isRequired,
};

export default ArticleAuthor;



// WEBPACK FOOTER //
// ./src/ui/src/component/article/articleAuthor.js